/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { MenuItem, ListItemText, Select, Checkbox } from '@mui/material';

const styles = {
  placeholder: {
    color: '#7e7c8a',
    textAlign: 'left',
    font: 'normal normal normal 16px/22px Nunito',
    letterSpacing: 0,
    opacity: 1,
    top: 0,
    left: 0,
    position: 'relative',
  },
  dropdown: {
    background: '#ffffff 0% 0% no-repeat padding-box',
    borderRadius: '4px',
    opacity: 1,
    width: '100%',
    height: '36px',
    padding: '4px 4px 4px 8px',
  },
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 100,
    },
  },
};

const DropDown = ((props, ref) => {
  const {
    type,
    required,
    error,
    label,
    disabled,
    ddoptionlist,
    placeholder,
    action,
    tooltiptext,
    defaultValue,
    onChange,
  } = props;
  const [optionValue, setOptionValue] = useState(defaultValue ? [defaultValue] : []);
  const [optionlist, setoptionlist] = useState(ddoptionlist);
  const [tooltipFlag, setShowTooltip] = useState(false)

  useEffect(() => {
      if(label == 'Devices' || label == 'MAC Address' || label == 'PAI') setOptionValue(defaultValue ? [defaultValue] : [])
      if(optionlist == null && ddoptionlist !== null) setoptionlist(ddoptionlist)
      if(optionlist !== null){
        setoptionlist(null);
        setoptionlist(ddoptionlist)
      }
  }, [ddoptionlist, optionlist]);

  const onSingleSelectDropdownChange = (val) => {
    const ddOptionList = [...optionlist];
    const ddDisplay = [val.target.value];
    ddOptionList && ddOptionList.forEach((item) => {
      if (item.name === val.target.value) {
        if (!item.checked) {
          item.checked = !item.checked;
        }
      } else {
        item.checked = false;
      }
    });
    setOptionValue(ddDisplay);
    setoptionlist(ddOptionList);
    onChange(val.target.value)
  };

  return (
    <div style={{ position: 'relative' }}>
      <se-form-field
        label={label}
        type={type}
        block
        required={required}
        disabled={disabled}
        status={error?"error":""}
        label-align='left'
      >
        {action? <span className='labelIcon' onMouseEnter={() => setShowTooltip(true)} onMouseLeave= {() => setShowTooltip(false)}><se-tooltip position='top' color="primary"><se-icon slot='trigger' option='raised'>{action}</se-icon>
      {tooltipFlag && (<pre>{tooltiptext}</pre>)}
      </se-tooltip></span> : null}
        <Select
          displayEmpty
          labelId='demo-dropdown-label'
          id='demo-dropdown'
          value={optionValue}
          onChange={onSingleSelectDropdownChange}
          renderValue={(selected) => {
            if (selected?.length === 0) {
              return <label style={styles.placeholder}>{placeholder? placeholder : 'Select'}</label>;
            }
            return selected?.join(', ');
          }}
          style={styles.dropdown}
        >
          <MenuItem value="" disabled>
            Select an option
          </MenuItem>
          {!disabled && optionlist && optionlist.map((ddval) => (
            <MenuItem key={ddval?.id} value={ddval?.name}>
              <ListItemText primary={ddval?.name} />
            </MenuItem>
          ))}
        </Select>
      </se-form-field>
      {error && (<span className='errorMsg'>{error}</span>)}
    </div>
  );
});

export default DropDown;

DropDown.propTypes = {
  ddoptionlist: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      checked: PropTypes.bool,
    }).isRequired,
  ),
  label: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  name: PropTypes.string,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  handleClick: PropTypes.func,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func
};
